import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, OnChanges, SimpleChanges, HostListener, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { IInputField } from './model/IInputField';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-input-search-box',
  templateUrl: './input-search-box.component.html',
  styleUrls: ['./input-search-box.component.scss']
})
export class InputSearchBoxComponent implements OnInit, OnChanges, OnDestroy {
  @Output() outputKeyword: EventEmitter<string> = new EventEmitter();
  @Output() isValidation: EventEmitter<boolean> = new EventEmitter();
  @Input() fieldDetails: IInputField = {
    lable: 'Email',
    placeholder: 'Enter Email',
    type: 'text',
    isServerError: true,
    serverErrorText: 'Email is required',
    isPatternValid: true,
    GstPatternValid: true,
    isValid: true,
  };
  @Input() inputValue: any = '';
  @Input() formSubmitted: boolean = false;
  @Input() disabled: boolean = false;
  @Input() pattern: RegExp | string | null = null;
  emailInput: any;
  @Input() rows: any = 3;

  isPatternValid: boolean = true;
  GstPatternValid: boolean = false;
  isPanValid: Boolean = true;
  isValid: Boolean = true;
  private searchSubject: Subject<string> = new Subject<string>();
  @Output() enterKeyPressed: EventEmitter<boolean> = new EventEmitter();
  @Output() inputChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor(private translate: TranslateService, private el: ElementRef) { }
  ngOnInit(): void {
    this.searchSubject
      .pipe(
        debounceTime(500),
        // distinctUntilChanged()
      )
      .subscribe(res => {
        this.outputKeyword.emit(res);
        // this.validationCheckFn();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.validationCheckFn();
    if (this.formSubmitted && this.inputValue) {
      this.validatePattern();
      this.validategstpattern();
    }
  }

  ngOnDestroy() {
    this.searchSubject.unsubscribe();
  }

  onInputChange(value: any) {
    if (this.fieldDetails.maxlength) {
      // Ensure the input is a number
      const numericValue = parseInt(this.inputValue, 10);
      // Check if the numericValue is a valid number
      if (!isNaN(numericValue)) {
        // Pad the number with leading zeros and limit to 4 digits
        this.inputValue = (''.repeat(this.fieldDetails.maxlength) + numericValue).slice(-this.fieldDetails.maxlength);
        document.getElementById(this.fieldDetails.formControlName).innerHTML = this.inputValue;
      }
      this.outputKeyword.emit(this.inputValue);
      return;
    }
    if (!this.fieldDetails.isSearchBox || !value) {
      this.searchSubject.next(value);
    }
    this.validatePattern();
    this.validategstpattern();
    this.inputChanged.emit(value);
    // if (this.fieldDetails.maxInputLength && value != null) {
    //   const trimmed = value.toString().slice(0, this.fieldDetails.maxInputLength);
    //   this.inputValue = trimmed;
    //   this.outputKeyword.emit(this.inputValue);
    // }

  }

  translatorFn(value) {
    return this.translate.instant(value);
  }

  onEnterKeyPressed(event: any) {
    if (event.keyCode === 13) {
      // this.searchSubject.next(event.target.value);
      this.outputKeyword.emit(event.target.value);
    }
  }

  onEnterPressed(event: any) {
    if (event.keyCode === 13) {
      this.enterKeyPressed.emit(true);
    }
  }

  validatePattern = (): boolean => {
    if (this.formSubmitted && this.fieldDetails.type === "email") {
      const regEx = new RegExp(this.pattern ? this.pattern : /[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})/);
      this.isPatternValid = regEx.test(this.inputValue);
    }
    this.fieldDetails.isPatternValid = this.isPatternValid
    return this.isPatternValid
  }

  validategstpattern() {
    if (this.fieldDetails.lable === "GST certificate") {
      const gstRegex = new RegExp(this.pattern ? this.pattern : /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);
      this.GstPatternValid = gstRegex.test(this.inputValue);
    }
    this.fieldDetails.GstPatternValid = this.GstPatternValid
    return this.GstPatternValid
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow only digits (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  blockInvalidPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    if (!clipboardData) {
      return; // nothing to check
    }
    // added by yash 05-08-2026
    const pastedText = clipboardData.getData('text');
    if (this.fieldDetails.type === 'alphabets') {
      if (!/^[a-zA-Z ]*$/.test(pastedText)) {
        event.preventDefault();
      }
    }
    if (this.fieldDetails.type === 'number') {
      if (!/^\d*$/.test(pastedText)) {
        event.preventDefault();
      }
    }
    // end by yash 05-08-2026
  }

  allowDigitsLength(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    if (this.fieldDetails.maxInputLength) {
      if (input.value.length >= this.fieldDetails.maxInputLength) {
        event.preventDefault();
      }
    }
  }

  // Added by priya - 17/06/2026 - cn(PRIYA-JUN26-006)
  allowAlphaWithLength(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    // allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }
    // block non alphabets
    const regex = /^[a-zA-Z ]$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
      return;
    }
    // enforce max length
    if (this.fieldDetails.maxInputLength) {
      if (input.value.length >= this.fieldDetails.maxInputLength) {
        event.preventDefault();
      }
    }
  }
  // End by priya

}
